(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"] && !Shopify.designMode) return;
  try {
    
class ArticleSlider {
  constructor(container) {
    this.container = container;
    this.slider = container.querySelector('.article-musardise__slider');
    this.track = container.querySelector('.article-musardise__slider-track');
    this.slides = Array.from(container.querySelectorAll('.article-musardise__slider-slide'));
    this.prevBtn = container.querySelector('.article-musardise__slider-arrow--prev');
    this.nextBtn = container.querySelector('.article-musardise__slider-arrow--next');
    
    if (!this.track || !this.slides.length) {
      console.log('Slider: pas de slides trouvées');
      return;
    }
    
    this.activeIndex = 0;
    this.maxIndex = 0;
    this.slideWidth = 695;
    this.gap = 20;
    this.visibleSlides = 1;
    
    console.log(`Slider initialisé avec ${this.slides.length} slides`);
    this.init();
  }
  
  init() {
    this.activeIndex = 0;
    this.bindEvents();
    this.updateCarousel();
  }
  
  bindEvents() {
    this.prevBtn?.addEventListener('click', () => this.prev());
    this.nextBtn?.addEventListener('click', () => this.next());
    
    // Mouse and touch events for smooth scrolling
    let isDown = false;
    let startX;
    let scrollLeft;
    
    this.track.addEventListener('mousedown', (e) => {
      isDown = true;
      this.track.style.cursor = 'grabbing';
      startX = e.pageX - this.track.offsetLeft;
      scrollLeft = this.track.scrollLeft;
    });
    
    this.track.addEventListener('mouseleave', () => {
      isDown = false;
      this.track.style.cursor = 'grab';
    });
    
    this.track.addEventListener('mouseup', () => {
      isDown = false;
      this.track.style.cursor = 'grab';
    });
    
    this.track.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - this.track.offsetLeft;
      const walk = (x - startX) * 2;
      this.track.scrollLeft = scrollLeft - walk;
    });
    
    // Touch events for mobile
    this.track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].pageX - this.track.offsetLeft;
      scrollLeft = this.track.scrollLeft;
    });
    
    this.track.addEventListener('touchmove', (e) => {
      const x = e.touches[0].pageX - this.track.offsetLeft;
      const walk = (x - startX) * 2;
      this.track.scrollLeft = scrollLeft - walk;
    });
    
    window.addEventListener('resize', () => this.updateCarousel());
  }
  
  prev() {
    if (this.activeIndex > 0) {
      this.activeIndex--;
      this.updateCarousel();
    }
  }
  
  next() {
    if (this.activeIndex < this.maxIndex) {
      this.activeIndex++;
      this.updateCarousel();
    }
  }
  
  updateCarousel() {
    // Calculer maxIndex basé sur le nombre de slides
    this.maxIndex = Math.max(0, this.slides.length - this.visibleSlides);
    
    // Limiter l'index actif
    this.activeIndex = Math.max(0, Math.min(this.activeIndex, this.maxIndex));
    
    if (this.slides.length <= this.visibleSlides) {
      // Tous les slides visibles - désactiver la navigation
      this.track.style.transform = 'translateX(0px)';
      this.prevBtn?.classList.add('disabled');
      this.nextBtn?.classList.add('disabled');
      this.progressFill && (this.progressFill.style.width = '0%');
      return;
    }
    
    // Calculer le décalage avec la largeur fixe
    const offset = this.activeIndex * (this.slideWidth + this.gap);
    this.track.style.transform = `translateX(-${offset}px)`;
    
    // Mettre à jour les boutons
    this.prevBtn?.classList.toggle('disabled', this.activeIndex <= 0);
    this.nextBtn?.classList.toggle('disabled', this.activeIndex >= this.maxIndex);
    

  }
}

// Initialize slider when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  const articleSection = document.querySelector('.article-musardise');
  if (articleSection) {
    new ArticleSlider(articleSection);
  }
});

// Re-initialisation pour les sections dynamiques
if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    const articleSection = document.querySelector('.article-musardise');
    if (articleSection) {
      new ArticleSlider(articleSection);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  class CartPage {
    constructor() {
      this.initSelectors();
      this.initEvents();
    }
    
    initSelectors() {
      this.cartForm = document.getElementById('cart-form');
      this.quantityInputs = document.querySelectorAll('.quantity-selector__input');
      this.minusButtons = document.querySelectorAll('[data-qty-minus]');
      this.plusButtons = document.querySelectorAll('[data-qty-plus]');
      this.removeButtons = document.querySelectorAll('.cart-item__remove');
    }
    
    initEvents() {
      document.addEventListener('click', (event) => {
        const minus = event.target.closest('[data-qty-minus]');
        const plus = event.target.closest('[data-qty-plus]');
        const remove = event.target.closest('.cart-item__remove');

        if (minus && minus.closest('#cart-form')) {
          event.preventDefault();
          this.handleMinusClick({ currentTarget: minus });
          return;
        }

        if (plus && plus.closest('#cart-form')) {
          event.preventDefault();
          this.handlePlusClick({ currentTarget: plus });
          return;
        }

        if (remove && remove.closest('#cart-form')) {
          this.handleRemoveClick({ currentTarget: remove });
        }
      });

      document.addEventListener('change', (event) => {
        const input = event.target.closest('#cart-form .quantity-selector__input');
        if (!input || input.hasAttribute('data-gift-wrap-qty')) return;
        this.handleQuantityChange({ target: input });
      });
    }
    
    handleMinusClick(event) {
      const button = event.currentTarget;
      const input = button.closest('.quantity-selector').querySelector('.quantity-selector__input');
      if (!input) return;
      const currentValue = parseInt(input.value, 10);
      
      if (currentValue > 1) {
        input.value = currentValue - 1;
        this.handleQuantityChange({ target: input });
      }
    }
    
    handlePlusClick(event) {
      const button = event.currentTarget;
      const input = button.closest('.quantity-selector').querySelector('.quantity-selector__input');
      if (!input) return;
      const currentValue = parseInt(input.value, 10) || 1;
      
      input.value = currentValue + 1;
      this.handleQuantityChange({ target: input });
    }
    
    // Fonction de debounce pour limiter les appels AJAX
    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }
    
    handleQuantityChange(event) {
      const input = event.target;
      const newQuantity = parseInt(input.value);
      const itemKey = input.dataset.itemKey;
      
      if (isNaN(newQuantity) || newQuantity < 1) {
        input.value = 1;
        return;
      }
      
      // Utiliser un debounce pour éviter trop d'appels AJAX
      if (!this.debouncedUpdateQuantity) {
        this.debouncedUpdateQuantity = this.debounce((key, qty) => {
          this.updateCartItem(key, qty);
        }, 200);
      }
      
      this.debouncedUpdateQuantity(itemKey, newQuantity);
    }
    
    handleRemoveClick(event) {
      const button = event.currentTarget;
      const itemKey = button.dataset.itemKey;
      const cartItem = button.closest('.cart-page__item');
      
      if (cartItem) {
        cartItem.classList.add('removing');
      }
      
      this.updateCartItem(itemKey, 0);
    }
    
    // Afficher un message de notification
    showNotification(message, type = 'success') {
      const notificationContainer = document.querySelector('.cart-notification') || this.createNotificationContainer();
      
      const notification = document.createElement('div');
      notification.className = `cart-notification__message cart-notification__message--${type}`;
      notification.textContent = message;
      
      notificationContainer.appendChild(notification);
      
      // Supprimer la notification après 3 secondes
      setTimeout(() => {
        notification.classList.add('cart-notification__message--hiding');
        setTimeout(() => {
          notification.remove();
          
          // Supprimer le conteneur s'il n'y a plus de notifications
          if (notificationContainer.children.length === 0) {
            notificationContainer.remove();
          }
        }, 300);
      }, 3000);
    }
    
    // Créer le conteneur de notification s'il n'existe pas
    createNotificationContainer() {
      const container = document.createElement('div');
      container.className = 'cart-notification';
      document.body.appendChild(container);
      return container;
    }
    
    async updateCartItem(itemKey, quantity) {
      try {
        // Afficher un indicateur de chargement
        document.body.classList.add('cart-updating');
        
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: itemKey,
            quantity: quantity
          })
        });
        
        if (!response.ok) {
          throw new Error('Erreur lors de la mise à jour du panier');
        }

        window.location.reload();
        return;
      } catch (error) {
        if (this.cartForm) {
          this.cartForm.submit();
          return;
        }
        this.showNotification(this.getNotificationMessage('error'), 'error');
      } finally {
        document.body.classList.remove('cart-updating');
      }
    }
    
    // Méthode pour récupérer les messages de notification depuis les data attributes
    getNotificationMessage(type) {
      const container = document.querySelector('[data-cart-notifications]');
      if (container) {
        switch(type) {
          case 'item_removed':
            return container.dataset.itemRemoved || 'Article retiré du panier';
          case 'cart_updated':
            return container.dataset.cartUpdated || 'Panier mis à jour';
          case 'error':
            return container.dataset.error || 'Une erreur est survenue';
          default:
            return 'Panier mis à jour';
        }
      }
      return 'Panier mis à jour';
    }
    
    updateCartUI(cart, updatedItemKey, newQuantity) {
      // Mettre à jour le compteur du panier dans le header
      this.updateCartCount(cart.item_count);
      
      // Mettre à jour le sous-total
      const subtotalElement = document.querySelector('.cart-page__subtotal-value');
      if (subtotalElement) {
    
        // Mettre à jour l'attribut data
        subtotalElement.setAttribute('data-cart-subtotal', cart.total_price);
        // Utiliser Shopify.formatMoney pour le formatage
        subtotalElement.textContent = formatMoney(cart.total_price);
      }
      
      if (newQuantity === 0) {
        // Supprimer l'élément du DOM si la quantité est 0
        const itemToRemove = document.querySelector(`.cart-page__item[data-key="${updatedItemKey}"]`);
        if (itemToRemove) {
          itemToRemove.style.height = itemToRemove.offsetHeight + 'px';
          setTimeout(() => {
            itemToRemove.style.height = '0';
            itemToRemove.style.opacity = '0';
            itemToRemove.style.margin = '0';
            itemToRemove.style.padding = '0';
            
            setTimeout(() => {
              itemToRemove.remove();
              
              // Vérifier si le panier est vide
              if (cart.item_count === 0) {
                this.showEmptyCartMessage();
              }
            }, 300);
          }, 10);
        }
      } else {
        // Mettre à jour les prix de ligne et les quantités
        cart.items.forEach(item => {
          const itemElement = document.querySelector(`.cart-page__item[data-key="${item.key}"]`);
          if (itemElement) {
            const priceElement = itemElement.querySelector('.cart-page__item-total');
            const quantityInput = itemElement.querySelector('.quantity-selector__input');
            
            if (priceElement) {
          
              // Mettre à jour l'attribut data
              priceElement.setAttribute('data-item-total', item.final_line_price);
              // Utiliser Shopify.formatMoney pour le formatage
              priceElement.textContent = formatMoney(item.final_line_price);
            }
            
            if (quantityInput && item.key === updatedItemKey) {
              quantityInput.value = item.quantity;
            }
          }
        });
      }
    }
    
    showEmptyCartMessage() {
      const cartItems = document.querySelector('.cart-page__items');
      const cartFooter = document.querySelector('.cart-page__footer');
      
      if (cartItems) {
        const emptyContainer = document.querySelector('[data-cart-empty]');
        if (emptyContainer) {
          cartItems.innerHTML = emptyContainer.innerHTML;
        } else {
          // Fallback si le conteneur de données n'existe pas
          cartItems.innerHTML = `
            <div class="cart-page__empty">
              <p class="cart-page__empty-message">Votre panier est vide</p>
              <div class="cart-page__empty-button">
                <a href="/collections/all" class="btn btn--primary">
                  Continuer vos achats
                </a>
              </div>
            </div>
          `;
        }
      }
      
      if (cartFooter) {
        cartFooter.style.display = 'none';
      }

      const cartExtras = document.querySelector('.cart-extras');
      if (cartExtras) cartExtras.style.display = 'none';
    }
    
    updateCartCount(count) {
      // Récupérer le nombre réel de produits (sans compter les composants de bundle)
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          // Filtrer les articles qui sont des composants de bundle
          // Les composants de bundle ont généralement une propriété _bundleId ou _component
          const realItemCount = cart.items.filter(item => {
            // Vérifier si l'article a des propriétés qui indiquent qu'il est un composant
            const isComponent = item.properties && (
              item.properties._bundleId || 
              item.properties._component || 
              item.properties._bundleComponent ||
              (item.properties._bundleParentId && item.properties._bundleParentId !== '')
            );
            return !isComponent;
          }).length;
          
          // Mettre à jour les compteurs avec le nombre réel de produits
          const cartCountElements = document.querySelectorAll('[data-cart-count]');
          cartCountElements.forEach(element => {
            element.textContent = realItemCount;
            element.dataset.cartCount = realItemCount;
          });
        })
        .catch(error => {
          console.error('Erreur lors de la récupération du panier:', error);
          // En cas d'erreur, utiliser le compte standard
          const cartCountElements = document.querySelectorAll('[data-cart-count]');
          cartCountElements.forEach(element => {
            element.textContent = count;
            element.dataset.cartCount = count;
          });
        });
    }
    
    // La fonction formatMoney a été supprimée car nous utilisons directement Shopify.formatMoney
  }

  function formatMoney(cents) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    const value = (Number(cents) / 100).toFixed(2).replace('.', ',');
    return value + ' €';
  }

  function hideUnlockedShippingZone() {
    if (!window.matchMedia('(max-width: 768px)').matches) return;

    document.querySelectorAll('.bogos-progress-success-label, .bogos-progress-goal-title, .bogos-progress-goal-description').forEach((node) => {
      const text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (text.length > 80 || !/frais de port d[ée]bloqu/i.test(text)) return;

      const zone = node.closest('.bogos-progress-success-label-container') || node;
      zone.style.setProperty('display', 'none', 'important');
    });
  }

  function initCartPage() {
    if (document.body.dataset.cartPageReady === 'true') return;
    document.body.dataset.cartPageReady = 'true';
    new CartPage();

    document.querySelectorAll('[data-upsell-add]').forEach((button) => {
      button.addEventListener('click', async () => {
        const variantId = button.getAttribute('data-variant-id');
        if (!variantId) return;

        button.disabled = true;
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: Number(variantId), quantity: 1 })
          });
          window.location.reload();
        } catch (error) {
          button.disabled = false;
        }
      });
    });

    function giftWrapQuantity(giftWrap) {
      const input = giftWrap && giftWrap.querySelector('[data-gift-wrap-qty]');
      if (!input) return 1;

      const min = Number(input.min) || 1;
      const max = Number(input.max) || 99;
      let quantity = parseInt(input.value, 10);
      if (!Number.isFinite(quantity)) quantity = min;
      quantity = Math.min(max, Math.max(min, quantity));
      input.value = quantity;
      return quantity;
    }

    document.addEventListener('click', (event) => {
      const minus = event.target.closest('[data-gift-wrap-qty-minus]');
      const plus = event.target.closest('[data-gift-wrap-qty-plus]');
      const button = minus || plus;
      if (!button) return;

      event.preventDefault();
      const giftWrap = button.closest('[data-gift-wrap]');
      const input = giftWrap && giftWrap.querySelector('[data-gift-wrap-qty]');
      if (!input) return;

      const current = parseInt(input.value, 10) || 1;
      input.value = minus ? current - 1 : current + 1;
      giftWrapQuantity(giftWrap);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      if (!event.target.closest('[data-gift-wrap-qty]')) return;
      event.preventDefault();
    });

    document.addEventListener('click', async (event) => {
      const addButton = event.target.closest('[data-gift-wrap-add]');
      if (!addButton) return;

      const giftWrap = addButton.closest('[data-gift-wrap]');
      const variantId = Number(giftWrap && giftWrap.dataset.variantId);
      if (!variantId) return;

      const quantity = giftWrapQuantity(giftWrap);
      const lineKey = giftWrap.dataset.lineKey;
      addButton.disabled = true;
      try {
        const response = lineKey
          ? await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: lineKey, quantity: quantity })
            })
          : await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: variantId, quantity: quantity })
            });
        if (!response.ok) throw new Error('cart');
        window.location.reload();
      } catch (error) {
        addButton.disabled = false;
      }
    });

    const giftWrapSlot = document.querySelector('[data-gift-wrap-slot]');
    if (giftWrapSlot && !giftWrapSlot.querySelector('[data-gift-wrap]')) {
      const wrapSku = 'pochette_cadeau_m';

      const loadProduct = (handle) =>
        fetch(`/products/${handle}.js`).then((response) => (response.ok ? response.json() : null));

      const variantBySku = (product) =>
        (product.variants || []).find((variant) => String(variant.sku || '').toLowerCase() === wrapSku);

      const isPochetteType = (product) =>
        String(product.product_type || product.type || '').toLowerCase().trim() === 'pochette';

      const findPochetteProduct = async () => {
        const suggest = await fetch('/search/suggest.json?q=pochette_cadeau_m&resources[type]=product&resources[limit]=10')
          .then((response) => response.json())
          .catch(() => null);
        const suggested = suggest && suggest.resources && suggest.resources.results
          ? suggest.resources.results.products || []
          : [];

        for (const item of suggested) {
          if (!item.handle) continue;
          const product = await loadProduct(item.handle);
          if (product && (variantBySku(product) || isPochetteType(product))) return product;
        }

        for (let page = 1; page <= 4; page += 1) {
          const data = await fetch(`/collections/all/products.json?limit=250&page=${page}`)
            .then((response) => response.json())
            .catch(() => null);
          const products = data && data.products ? data.products : [];
          const bySku = products.find((product) =>
            (product.variants || []).some((variant) => String(variant.sku || '').toLowerCase() === wrapSku)
          );
          if (bySku) return loadProduct(bySku.handle);

          const byType = products.find((product) => isPochetteType(product));
          if (byType) return loadProduct(byType.handle);
          if (products.length < 250) break;
        }

        return null;
      };

      findPochetteProduct().then((product) => {
        if (!product || !product.variants || !product.variants[0]) return;

        const variant = variantBySku(product) || product.variants[0];
        const image = product.featured_image || '';
        const price = formatMoney(variant.price);
        let maxQty = 99;
        if (variant.inventory_management && variant.inventory_policy === 'deny' && Number(variant.inventory_quantity) > 0) {
          maxQty = Math.min(maxQty, Number(variant.inventory_quantity));
        }

        giftWrapSlot.innerHTML = `
          <div class="cart-gift-wrap" data-gift-wrap data-variant-id="${variant.id}">
            <div class="cart-gift-wrap__media">
              ${image ? `<img src="${image}" alt="" class="cart-gift-wrap__image" width="160" height="160">` : ''}
            </div>
            <div class="cart-gift-wrap__content">
              ${product.description ? `<div class="cart-gift-wrap__description">${product.description}</div>` : ''}
              <p class="cart-gift-wrap__price price">${price}</p>
              <div class="cart-gift-wrap__actions">
                <div class="quantity-selector">
                  <button type="button" class="quantity-selector__btn quantity-selector__btn--minus" data-gift-wrap-qty-minus aria-label="Diminuer la quantité">-</button>
                  <input type="number" value="1" min="1" max="${maxQty}" inputmode="numeric" class="quantity-selector__input" data-gift-wrap-qty aria-label="Quantité">
                  <button type="button" class="quantity-selector__btn quantity-selector__btn--plus" data-gift-wrap-qty-plus aria-label="Augmenter la quantité">+</button>
                </div>
                <button type="button" class="btn btn--secondary cart-gift-wrap__button" data-gift-wrap-add>
                  Ajouter au panier
                </button>
              </div>
            </div>
          </div>
        `;
      }).catch(() => {});
    }
  }

    hideUnlockedShippingZone();
    document.addEventListener('bogos:progress-render', hideUnlockedShippingZone);
    document.addEventListener('bogos:progress-rerender', hideUnlockedShippingZone);
    window.setTimeout(hideUnlockedShippingZone, 400);
    window.setTimeout(hideUnlockedShippingZone, 1200);

    if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartPage);
  } else {
    initCartPage();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-accordeon"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const accordions = document.querySelectorAll('.js-collection-accordion');
  
  accordions.forEach(function(details) {
    const summary = details.querySelector('.collection-accordion__summary');
    const content = details.querySelector('.collection-accordion__content');
    
    if (!summary || !content) return;
    
    // Initial state
    if (details.hasAttribute('open')) {
      content.style.maxHeight = content.scrollHeight + 'px';
      content.style.opacity = '1';
    } else {
      content.style.maxHeight = '0px';
      content.style.opacity = '0';
    }
    
    summary.addEventListener('click', function(e) {
      e.preventDefault();
      
      const isOpen = details.hasAttribute('open');
      
      // Close all other accordions
      accordions.forEach(function(otherDetails) {
        if (otherDetails !== details && otherDetails.hasAttribute('open')) {
          const otherContent = otherDetails.querySelector('.collection-accordion__content');
          if (otherContent) {
            otherContent.style.maxHeight = '0px';
            otherContent.style.opacity = '0';
            setTimeout(function() { 
              otherDetails.removeAttribute('open'); 
            }, 300);
          }
        }
      });
      
      // Toggle current accordion
      if (isOpen) {
        content.style.maxHeight = '0px';
        content.style.opacity = '0';
        setTimeout(function() { 
          details.removeAttribute('open'); 
        }, 300);
      } else {
        details.setAttribute('open', 'open');
        content.style.maxHeight = content.scrollHeight + 'px';
        setTimeout(function() { 
          content.style.opacity = '1'; 
        }, 50);
      }
    });
    
    // Set transition
    content.style.transition = 'max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s';
    
    // Close if click outside
    document.addEventListener('click', function(event) {
      if (!details.contains(event.target)) {
        content.style.maxHeight = '0px';
        content.style.opacity = '0';
        setTimeout(function() { 
          details.removeAttribute('open'); 
        }, 300);
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-products-grid"] && !Shopify.designMode) return;
  try {
    
// Collection Products Grid - Gestion des produits, tri et pagination
document.addEventListener('DOMContentLoaded', () => {
  console.log('Collection Products Grid: Initialisation...');
  
  const debugMode = false;
  
  const collectionGrid = document.querySelector('[data-collection-grid]');
  if (!collectionGrid) {
    console.error('❌ Collection grid non trouvée');
    return;
  }

  // Éléments DOM
  const sortSelect = collectionGrid.querySelector('[data-collection-sort]');
  const productsContainer = collectionGrid.querySelector('[data-collection-products]');
  const activeFiltersContainer = collectionGrid.querySelector('[data-active-filters-container]');
  const activeFiltersList = collectionGrid.querySelector('[data-active-filters-list]');
  const clearAllButton = collectionGrid.querySelector('[data-clear-all-filters]');
  const clearFiltersButton = collectionGrid.querySelector('[data-clear-filters]');
  const filtersCount = collectionGrid.querySelector('[data-active-filters-count]');
  const filtersToggle = collectionGrid.querySelector('[data-filters-toggle]');

  let currentUrl = new URL(window.location.href);
  let activeFilters = new Map();

  // Fonctions utilitaires
  const parseActiveFilters = () => {
    if (debugMode) {
      console.log('🔍 Parsing des filtres actifs depuis URL:', currentUrl.search);
    }
    
    activeFilters.clear();
    const searchParams = currentUrl.searchParams;
    
    // Parcourir tous les paramètres de l'URL
    searchParams.forEach((value, key) => {
      // Vérifier si c'est un paramètre de filtre
      if (key.startsWith('filter.') || 
          key === 'q' || 
          key.includes('price') || 
          key === 'availability' ||
          key === 'product_type' ||
          key === 'vendor' ||
          key.startsWith('variant')) {
        
        let filterName = key;
        let paramKey = key;
        
        // Normaliser les noms de filtres
        if (key.startsWith('filter.p.')) {
          // Prix, tags, etc.
          filterName = key.replace('filter.p.', '');
        } else if (key.startsWith('filter.v.')) {
          // Variants (couleur, taille, etc.)
          filterName = key.replace('filter.v.', '');
        } else if (key.startsWith('filter.')) {
          filterName = key.replace('filter.', '');
        }
        
        // Gérer les valeurs multiples séparées par des virgules
        const filterValues = value.split(',');
        
        filterValues.forEach(filterValue => {
          if (filterValue && filterValue.trim()) {
            const filterKey = `${paramKey}:${filterValue}`;
            activeFilters.set(filterKey, {
              name: filterName,
              value: filterValue,
              param: paramKey,
              displayName: formatFilterDisplayName(filterName, filterValue)
            });
          }
        });
      }
    });
    
    if (debugMode) {
      console.log(`📊 Total filtres actifs: ${activeFilters.size}`, activeFilters);
    }
  };

  const formatFilterDisplayName = (name, value) => {
    const nameMap = {
      'tag': 'Catégorie',
      'product_type': 'Type',
      'vendor': 'Marque',
      'availability': 'Disponibilité',
      'available': 'Disponibilité',
      'price.gte': 'Prix min',
      'price.lte': 'Prix max',
      'price_min': 'Prix min',
      'price_max': 'Prix max',
      'option.color': 'Couleur',
      'option.size': 'Taille',
      'option.Color': 'Couleur',
      'option.Size': 'Taille',
      'option.Couleur': 'Couleur',
      'option.Taille': 'Taille'
    };
    
    // Chercher dans la map des noms
    let displayName = nameMap[name];
    
    // Si pas trouvé, essayer de formater le nom
    if (!displayName) {
      if (name.includes('option.')) {
        const optionName = name.split('.')[1];
        displayName = optionName.charAt(0).toUpperCase() + optionName.slice(1);
      } else if (name.includes('.')) {
        displayName = name.split('.').pop();
      } else {
        displayName = name.charAt(0).toUpperCase() + name.slice(1).replace(/_/g, ' ');
      }
    }
    
    // Formater la valeur pour certains cas spéciaux
    if ((name === 'available' || name === 'availability') && value === '1') {
      return 'En stock uniquement';
    }
    
    if (name.includes('price')) {
      // Essayer de parser comme un nombre
      const priceNum = parseFloat(value);
      if (!isNaN(priceNum)) {
        // Si c'est en centimes (> 100), convertir en euros
        const price = priceNum > 100 ? priceNum / 100 : priceNum;
        const formattedPrice = new Intl.NumberFormat('fr-FR', {
          style: 'currency',
          currency: 'EUR'
        }).format(price);
        return `${displayName}: ${formattedPrice}`;
      }
    }

    // Format final
    return `${displayName}: ${value}`;
  };

  const updateActiveFiltersDisplay = () => {
    if (debugMode) {
      console.log('🎨 Mise à jour affichage des filtres actifs...');
    }
    
    if (!activeFiltersContainer || !activeFiltersList) {
      console.warn('⚠️ Conteneurs de filtres non trouvés');
      return;
    }

    if (activeFilters.size === 0) {
      activeFiltersContainer.style.display = 'none';
      if (filtersCount) {
        filtersCount.style.display = 'none';
        filtersCount.textContent = '(0)';
      }
      return;
    }

    // Afficher le conteneur
    activeFiltersContainer.style.display = 'flex';
    
    // Mettre à jour le compteur
    if (filtersCount) {
      filtersCount.style.display = 'inline';
      filtersCount.textContent = `(${activeFilters.size})`;
    }

    // Vider la liste actuelle
    activeFiltersList.innerHTML = '';

    // Créer les badges
    activeFilters.forEach((filter, key) => {
      const badge = createFilterBadge(filter, key);
      activeFiltersList.appendChild(badge);
    });
  };

  const createFilterBadge = (filter, key) => {
    const badge = document.createElement('div');
    badge.className = 'active-filter-badge';
    badge.innerHTML = `
      <span class="active-filter-badge__text">${filter.displayName}</span>
      <button type="button" class="active-filter-badge__remove" aria-label="Supprimer le filtre ${filter.displayName}"></button>
    `;

    const removeButton = badge.querySelector('.active-filter-badge__remove');
    removeButton.addEventListener('click', () => {
      removeFilter(key);
    });

    return badge;
  };

  const removeFilter = (filterKey) => {
    if (!activeFilters.has(filterKey)) return;

    const filter = activeFilters.get(filterKey);
    activeFilters.delete(filterKey);

    const searchParams = currentUrl.searchParams;
    const currentValue = searchParams.get(filter.param);
    
    if (currentValue) {
      const values = currentValue.split(',').filter(v => v !== filter.value);
      if (values.length > 0) {
        searchParams.set(filter.param, values.join(','));
      } else {
        searchParams.delete(filter.param);
      }
    }

    // Réinitialiser la page à 1
    searchParams.delete('page');
    updateCollection();
  };

  const clearAllFilters = () => {
    if (debugMode) {
      console.log('🧹 Effacement de tous les filtres');
    }
    
    activeFilters.clear();
    
    const searchParams = currentUrl.searchParams;
    const keysToDelete = [];
    
    // Collecter toutes les clés à supprimer
    searchParams.forEach((value, key) => {
      if (key.startsWith('filter.') || 
          key === 'availability' || 
          key.includes('price') || 
          key === 'q' ||
          key === 'product_type' ||
          key === 'vendor' ||
          key.startsWith('variant')) {
        keysToDelete.push(key);
      }
    });
    
    // Supprimer les clés
    keysToDelete.forEach(key => searchParams.delete(key));
    searchParams.delete('page');
    
    updateCollection();
  };

  const updateSort = (sortValue) => {
    if (debugMode) {
      console.log(`🔄 Changement de tri: ${sortValue}`);
    }
    
    if (sortValue === 'manual') {
      currentUrl.searchParams.delete('sort_by');
    } else {
      currentUrl.searchParams.set('sort_by', sortValue);
    }
    
    currentUrl.searchParams.delete('page');
    updateCollection();
  };

  const updateCollection = () => {
    if (debugMode) {
      console.log('🔄 Mise à jour de la collection...');
      console.log('🌍 Redirection vers:', currentUrl.toString());
    }
    
    // Redirection simple - laisse Shopify gérer le filtrage
    window.location.href = currentUrl.toString();
  };

  // Event Listeners
  if (sortSelect) {
    sortSelect.addEventListener('change', (e) => {
      updateSort(e.target.value);
    });
  }

  if (clearAllButton) {
    clearAllButton.addEventListener('click', () => {
      clearAllFilters();
    });
  }

  if (clearFiltersButton) {
    clearFiltersButton.addEventListener('click', () => {
      clearAllFilters();
    });
  }

  // Gestion du bouton filtres (pour ouvrir le drawer)
  if (filtersToggle) {
    filtersToggle.addEventListener('click', () => {
      if (debugMode) {
        console.log('🎯 Ouverture du drawer de filtres');
      }
      // Déclencher l'événement pour ouvrir le drawer
      document.dispatchEvent(new CustomEvent('filters:open'));
    });
  }

  // Écouter les événements de filtres du drawer
  document.addEventListener('collection:filter-changed', (e) => {
    if (debugMode) {
      console.log('📬 Événement filtre reçu:', e.detail);
    }
    
    if (e.detail && e.detail.url) {
      currentUrl = new URL(e.detail.url);
      updateCollection();
    }
  });

  // Initialisation
  parseActiveFilters();
  updateActiveFiltersDisplay();
  
  if (debugMode) {
    console.log('✅ Collection Products Grid initialisé avec succès');
    console.log('📊 État initial:', {
      url: currentUrl.toString(),
      filtresActifs: activeFilters.size,
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edito-accordion"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const accordions = document.querySelectorAll('.js-edito-accordion');
  
  accordions.forEach(function(details) {
    const summary = details.querySelector('.edito-accordion__summary');
    const content = details.querySelector('.edito-accordion__content');
    
    if (!summary || !content) return;
    
    // Initial state
    if (details.hasAttribute('open')) {
      content.style.maxHeight = content.scrollHeight + 'px';
      content.style.opacity = '1';
    } else {
      content.style.maxHeight = '0px';
      content.style.opacity = '0';
    }
    
    summary.addEventListener('click', function(e) {
      e.preventDefault();
      
      const isOpen = details.hasAttribute('open');
      
      // Close all other accordions
      accordions.forEach(function(otherDetails) {
        if (otherDetails !== details && otherDetails.hasAttribute('open')) {
          const otherContent = otherDetails.querySelector('.edito-accordion__content');
          if (otherContent) {
            otherContent.style.maxHeight = '0px';
            otherContent.style.opacity = '0';
            setTimeout(function() { 
              otherDetails.removeAttribute('open'); 
            }, 300);
          }
        }
      });
      
      // Toggle current accordion
      if (isOpen) {
        content.style.maxHeight = '0px';
        content.style.opacity = '0';
        setTimeout(function() { 
          details.removeAttribute('open'); 
        }, 300);
      } else {
        details.setAttribute('open', 'open');
        content.style.maxHeight = content.scrollHeight + 'px';
        setTimeout(function() { 
          content.style.opacity = '1'; 
        }, 50);
      }
    });
    
    // Set transition
    content.style.transition = 'max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s';
    
    // Close if click outside
    document.addEventListener('click', function(event) {
      if (!details.contains(event.target)) {
        content.style.maxHeight = '0px';
        content.style.opacity = '0';
        setTimeout(function() { 
          details.removeAttribute('open'); 
        }, 300);
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const accordions = document.querySelectorAll('.js-faq-accordion');
  accordions.forEach(function(details) {
    const summary = details.querySelector('summary');
    const content = details.querySelector('.faq-page__answer');
    if (!summary || !content) return;
    // Initial state
    if (details.hasAttribute('open')) {
      content.style.maxHeight = content.scrollHeight + 'px';
      content.style.opacity = '1';
    } else {
      content.style.maxHeight = '0px';
      content.style.opacity = '0';
    }
    summary.addEventListener('click', function(e) {
      e.preventDefault();
      const isOpen = details.hasAttribute('open');
      if (isOpen) {
        content.style.maxHeight = '0px';
        content.style.opacity = '0';
        setTimeout(function() { details.removeAttribute('open'); }, 300);
      } else {
        details.setAttribute('open', 'open');
        content.style.maxHeight = content.scrollHeight + 'px';
        setTimeout(function() { content.style.opacity = '1'; }, 50);
      }
    });
    // Transition
    content.style.transition = 'max-height 0.3s cubic-bezier(0.4,0,0.2,1), opacity 0.25s';
    // Fermer si clic ailleurs
    document.addEventListener('click', function(event) {
      if (!details.contains(event.target)) {
        content.style.maxHeight = '0px';
        content.style.opacity = '0';
        setTimeout(function() { details.removeAttribute('open'); }, 300);
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  class FeaturedCollectionCarousel extends HTMLElement {
    constructor() {
      super();
      this.carousel = this.querySelector('[data-carousel]');
      if (!this.carousel) return;
      
      this.track = this.querySelector('.carousel-track');
      this.slides = this.querySelectorAll('.carousel-slide');
      this.prevBtn = this.querySelector('.carousel-btn--prev');
      this.nextBtn = this.querySelector('.carousel-btn--next');
      this.dots = this.querySelectorAll('.carousel-dot');
      
      this.currentIndex = 0;
      this.slidesToShow = this.getSlidesToShow();
      this.totalSlides = this.slides.length;
      this.maxIndex = Math.max(0, this.totalSlides - this.slidesToShow);
      
      this.autoplay = this.carousel.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(this.carousel.dataset.autoplaySpeed) || 3000;
      this.autoplayTimer = null;
      
      this.init();
    }
    
    init() {
      this.setupEventListeners();
      this.updateCarousel();
      
      if (this.autoplay) {
        this.startAutoplay();
      }
      
      // Handle resize
      window.addEventListener('resize', () => {
        this.slidesToShow = this.getSlidesToShow();
        this.maxIndex = Math.max(0, this.totalSlides - this.slidesToShow);
        this.currentIndex = Math.min(this.currentIndex, this.maxIndex);
        this.updateCarousel();
      });
    }
    
    getSlidesToShow() {
      const style = getComputedStyle(this);
      const columns = window.innerWidth >= 768 
        ? parseInt(style.getPropertyValue('--columns-desktop')) || 4
        : parseInt(style.getPropertyValue('--columns-mobile')) || 2;
      return Math.min(columns, this.totalSlides);
    }
    
    setupEventListeners() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.prev());
      }
      
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.next());
      }
      
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });
      
      // Pause autoplay on hover
      if (this.autoplay) {
        this.carousel.addEventListener('mouseenter', () => this.stopAutoplay());
        this.carousel.addEventListener('mouseleave', () => this.startAutoplay());
      }
    }
    
    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.updateCarousel();
      }
    }
    
    next() {
      if (this.currentIndex < this.maxIndex) {
        this.currentIndex++;
        this.updateCarousel();
      }
    }
    
    goToSlide(index) {
      this.currentIndex = Math.min(index, this.maxIndex);
      this.updateCarousel();
    }
    
    updateCarousel() {
      if (!this.track) return;
      
      const slideWidth = 100 / this.slidesToShow;
      const translateX = -(this.currentIndex * slideWidth);
      
      this.track.style.transform = `translateX(${translateX}%)`;
      
      // Update buttons
      if (this.prevBtn) {
        this.prevBtn.disabled = this.currentIndex === 0;
      }
      
      if (this.nextBtn) {
        this.nextBtn.disabled = this.currentIndex >= this.maxIndex;
      }
      
      // Update dots
      this.dots.forEach((dot, index) => {
        dot.classList.toggle('carousel-dot--active', index === this.currentIndex);
      });
    }
    
    startAutoplay() {
      if (!this.autoplay) return;
      
      this.stopAutoplay();
      this.autoplayTimer = setInterval(() => {
        if (this.currentIndex >= this.maxIndex) {
          this.currentIndex = 0;
        } else {
          this.currentIndex++;
        }
        this.updateCarousel();
      }, this.autoplaySpeed);
    }
    
    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }
  
  customElements.define('featured-collection-carousel', FeaturedCollectionCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  // Variables globales
  let isScrolled = false;
  let ticking = false;
  
  // Fonctions globales accessibles partout
  function hasActiveInteractions() {
    const header = document.querySelector('.header');
    return (
      header.matches(':hover') ||
      document.querySelector('.header__navigation:hover') ||
      document.querySelector('.nav-item:hover') ||
      document.querySelector('.nav-link:hover') ||
      document.querySelector('.mini-cart.is-active') ||
      document.querySelector('.mega-menu-bijoux[style*="opacity: 1"]') ||
      document.querySelector('.mega-menu-collections[style*="opacity: 1"]') ||
      document.querySelector('.mega-menu-cadeaux[style*="opacity: 1"]')
    );
  }
  
  function updateHeaderState() {
    const header = document.querySelector('.header');
    const mobileHeader = document.querySelector('.header__mobile');
    const body = document.body;
    const scrollY = window.scrollY;
    const shouldBeScrolled = scrollY > 50;
    const isHomePage = header.dataset.templateName === 'index';

    // Gérer la classe header-hovering selon l'état
    // Actif lors d'interactions réelles (hover, mega-menu ouvert, mini-cart actif)
    // OU par défaut sur les pages autres que l'accueil quand on est en haut
    const shouldHaveHoverState = hasActiveInteractions() || (!isHomePage && !shouldBeScrolled);
    
    if (shouldHaveHoverState) {
      header.classList.add('header-hovering');
      // Supprimer temporairement la classe scrolled au hover
      header.classList.remove('scrolled');
    } else {
      header.classList.remove('header-hovering');
      // Mettre à jour l'état de scroll
      if (shouldBeScrolled !== isScrolled) {
        isScrolled = shouldBeScrolled;
        if (isScrolled) {
          body.classList.add('header-scrolled');
        } else {
          body.classList.remove('header-scrolled');
        }
      }
      
      // Gérer la classe scrolled selon l'état actuel
      if (isScrolled) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }

    // Gérer le header mobile et son positionnement
    if (mobileHeader) {
      /*if (isScrolled) {
        // Quand on scroll, la topbar disparaît et le header mobile remonte
        mobileHeader.style.top = '0px';
      } else {
        // Position normale : sous la topbar
        const announcementHeight = document.querySelector('.header__announcement')?.offsetHeight || 30;
        mobileHeader.style.top = announcementHeight + 'px';
      }*/
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    setupScrollAnimation();
    setupMobileMenu();
    setupSearch();
    updateCartCount();
    setupMegaMenus();
  });

  function setupScrollAnimation() {
    const header = document.querySelector('.header');
    const isHomePage = header.dataset.templateName === 'index';

    const updateHeaderOnScroll = () => {
      updateHeaderState();
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(updateHeaderOnScroll);
        ticking = true;
      }
    };

    // Gestion du hover sur le header
    header.addEventListener('mouseenter', () => {
      updateHeaderState();
    });

    header.addEventListener('mouseleave', () => {
      // Petit délai pour permettre le passage vers les mega menus
      setTimeout(() => {
        updateHeaderState();
      }, 100);
    });

    // Throttled scroll listener
    window.addEventListener('scroll', onScroll, { passive: true });

    // Initial check
    updateHeaderState();
    setupMiniCart();
  }

  function setupMiniCart() {
    const cartIconWrapper = document.querySelector('.header__cart-icon-wrapper');
    const miniCart = document.querySelector('#mini-cart');
    const closeButton = miniCart.querySelector('.mini-cart__close-button');
    const header = document.querySelector('.header');
    let timeout;
    let isOverCart = false;
    let isOverMiniCart = false;

    if (!cartIconWrapper || !miniCart) return;

    const showMiniCart = () => {
      clearTimeout(timeout);
      miniCart.style.display = 'block';
      setTimeout(() => {
        miniCart.classList.add('is-active');
        updateHeaderState();
      }, 10);
    };

    const hideMiniCart = () => {
      if (!isOverCart && !isOverMiniCart) {
        miniCart.classList.remove('is-active');
        
        timeout = setTimeout(() => {
          miniCart.style.display = 'none';
          updateHeaderState();
        }, 300);
      }
    };

    cartIconWrapper.addEventListener('mouseenter', () => {
      isOverCart = true;
      showMiniCart();
    });
    
    cartIconWrapper.addEventListener('mouseleave', () => {
      isOverCart = false;
      setTimeout(hideMiniCart, 200);
    });

    miniCart.addEventListener('mouseenter', () => {
      isOverMiniCart = true;
    });
    
    miniCart.addEventListener('mouseleave', () => {
      isOverMiniCart = false;
      setTimeout(hideMiniCart, 200);
    });

    closeButton.addEventListener('click', (event) => {
      event.preventDefault();
      isOverCart = false;
      isOverMiniCart = false;
      hideMiniCart();
    });
  }

function setupMobileMenu() {
  const toggle = document.querySelector('[data-mobile-menu-toggle]');
  const overlay = document.querySelector('[data-mobile-menu-overlay]');
  const menu = document.querySelector('[data-mobile-menu]');
  const back = document.querySelector('[data-mobile-menu-back]');
  const close = document.querySelector('[data-mobile-menu-close]');
  const title = document.querySelector('[data-mobile-menu-title]');
  const content = document.querySelector('[data-mobile-menu-content]');

  const menuIcon = toggle?.querySelector('.menu-icon');
  const closeIcon = toggle?.querySelector('.close-icon');
  
  if (!toggle || !overlay || !menu || !content) return;

  // Stack pour gérer l'historique de navigation
  let navigationStack = [];
  let currentPanel = null;
  let allPanels = []; // Garder trace de tous les panneaux créés

  // Récupération des données des mega menus depuis le DOM
  const getMegaMenuData = () => {
    const megaMenus = {
      bijoux: [],
      collections: [],
      cadeaux: []
    };

    // Extraire les données de Bijoux
    const bijouxMenu = document.querySelector('.mega-menu-bijoux');
    if (bijouxMenu) {
      const bijouxCategories = bijouxMenu.querySelectorAll('.mega-menu-bijoux__category-item, .bijoux-link');
      bijouxCategories.forEach(category => {
        const titleEl = category.querySelector('.mega-menu-bijoux__category-title, .bijoux-link__main');
        if (titleEl) {
          const categoryData = {
            title: titleEl.textContent.trim(),
            url: category.querySelector('a')?.href || '#',
            hasSubmenu: false,
            sublinks: []
          };

          // Chercher les sous-liens
          const sublinkContainer = category.querySelector('.mega-menu-bijoux__subcategories, .bijoux-link-sublinks');
          if (sublinkContainer) {
            const sublinks = sublinkContainer.querySelectorAll('a');
            sublinks.forEach(sublink => {
              categoryData.sublinks.push({
                title: sublink.textContent.trim(),
                url: sublink.href
              });
            });
            categoryData.hasSubmenu = categoryData.sublinks.length > 0;
          }

          megaMenus.bijoux.push(categoryData);
        }
      });
    }

    // Extraire les données de Cadeaux
    const cadeauxMenu = document.querySelector('.mega-menu-cadeaux');
    if (cadeauxMenu) {
      const cadeauxCategories = cadeauxMenu.querySelectorAll('.mega-menu-cadeaux__category-item, .cadeaux-link');
      cadeauxCategories.forEach(category => {
        const titleEl = category.querySelector('.mega-menu-cadeaux__category-title, .cadeaux-link__main');
        if (titleEl) {
          const categoryData = {
            title: titleEl.textContent.trim(),
            url: category.querySelector('a')?.href || '#',
            hasSubmenu: false,
            sublinks: []
          };

          // Chercher les sous-liens
          const sublinkContainer = category.querySelector('.mega-menu-cadeaux__subcategories, .cadeaux-link-sublinks');
          if (sublinkContainer) {
            const sublinks = sublinkContainer.querySelectorAll('a');
            sublinks.forEach(sublink => {
              categoryData.sublinks.push({
                title: sublink.textContent.trim(),
                url: sublink.href
              });
            });
            categoryData.hasSubmenu = categoryData.sublinks.length > 0;
          }

          megaMenus.cadeaux.push(categoryData);
        }
      });
    }

    // Extraire les données de Collections avec images
    const collectionsMenu = document.querySelector('.mega-menu-collections');
    if (collectionsMenu) {
      const collectionCards = collectionsMenu.querySelectorAll('.mega-menu-collections__card');
      
      collectionCards.forEach(card => {
        const titleEl = card.querySelector('.mega-menu-collections__title');
        const linkUrl = card.href;
        const imageEl = card.querySelector('.mega-menu-collections__image');
        
        if (titleEl && linkUrl) {
          megaMenus.collections.push({
            title: titleEl.textContent.trim(),
            url: linkUrl,
            hasSubmenu: false,
            image: imageEl ? imageEl.src : null
          });
        }
      });
    }

    // Données par défaut si vides
    /*if (megaMenus.bijoux.length === 0) {
      megaMenus.bijoux = [
        { 
          title: 'Bagues', 
          url: '/collections/bagues', 
          hasSubmenu: true, 
          sublinks: [
            { title: 'Bagues en or', url: '/collections/bagues-or' },
            { title: 'Bagues en argent', url: '/collections/bagues-argent' }
          ]
        },
        { 
          title: 'Colliers', 
          url: '/collections/colliers', 
          hasSubmenu: true, 
          sublinks: [
            { title: 'Colliers courts', url: '/collections/colliers-courts' },
            { title: 'Colliers longs', url: '/collections/colliers-longs' }
          ]
        },
        { title: 'Bracelets', url: '/collections/bracelets', hasSubmenu: false },
        { title: 'Boucles d\'oreilles', url: '/collections/boucles-oreilles', hasSubmenu: false }
      ];
    }*/

    /*if (megaMenus.collections.length === 0) {
      // Collections par défaut avec placeholder
      megaMenus.collections = [
        { title: 'Collection Été', url: '/collections/ete', hasSubmenu: false, image: null },
        { title: 'Collection Hiver', url: '/collections/hiver', hasSubmenu: false, image: null },
        { title: 'Collection Automne', url: '/collections/automne', hasSubmenu: false, image: null }
      ];
    }*/

    return megaMenus;
  };

  // Créer un panneau de navigation pour les collections avec images
  const createCollectionsPanel = (items, panelTitle) => {
    const panel = document.createElement('div');
    panel.className = 'mobile-menu__panel';
    panel.dataset.title = panelTitle;

    const wrapper = document.createElement('div');
    wrapper.className = 'mobile-collections-wrapper';

    // Lien "Voir toutes les collections"
    /*
    const allLink = document.createElement('a');
    allLink.href = '/collections';
    allLink.className = 'mobile-nav-link mobile-nav-link--all';
    allLink.innerHTML = `<span>Voir toutes les collections</span>`;
    wrapper.appendChild(allLink);
    */

    // Grille des collections avec images
    const grid = document.createElement('div');
    grid.className = 'mobile-collections-grid';

    items.forEach(item => {
      const collectionItem = document.createElement('a');
      collectionItem.href = item.url;
      collectionItem.className = 'mobile-collection-item';
      
      if (item.image) {
        collectionItem.innerHTML = `
          <div class="mobile-collection-image">
            <img src="${item.image}" alt="${item.title}" loading="lazy">
          </div>
          <div class="mobile-collection-title">${item.title}</div>
        `;
      } else {
        // Placeholder si pas d'image
        collectionItem.innerHTML = `
          <div class="mobile-collection-image mobile-collection-image--placeholder">
            <span>${item.title.charAt(0)}</span>
          </div>
          <div class="mobile-collection-title">${item.title}</div>
        `;
      }

      grid.appendChild(collectionItem);
    });

    wrapper.appendChild(grid);
    panel.appendChild(wrapper);
    return panel;
  };

  // Créer un panneau de navigation standard
  const createPanel = (items, panelTitle, isMainMenu = false) => {
    const panel = document.createElement('div');
    panel.className = 'mobile-menu__panel';
    panel.dataset.title = panelTitle;

    const list = document.createElement('ul');
    list.className = 'mobile-nav-list';

    // Ajouter un lien "Voir tous" pour les sous-menus
    if (!isMainMenu && panelTitle !== 'Menu') {
      const allItem = document.createElement('li');
      allItem.className = 'mobile-nav-item';
      const urlForAll = items[0]?.url || '#';
      /*allItem.innerHTML = `
        <a href="${urlForAll}" class="mobile-nav-link mobile-nav-link--all">
          <span>Voir tous les ${panelTitle.toLowerCase()}</span>
        </a>
      `; */
      list.appendChild(allItem);
    }

    // Créer les éléments de menu
    items.forEach(item => {
      const li = document.createElement('li');
      li.className = 'mobile-nav-item';

      if (item.hasSubmenu && item.sublinks && item.sublinks.length > 0) {
        li.innerHTML = `
          <button class="mobile-nav-link mobile-nav-link--with-submenu" type="button">
            <span>${item.title}</span>
            <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 4L13 10L7 16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        `;
        
        const button = li.querySelector('button');
        button.addEventListener('click', () => {
          if (item.title === 'Collections' || panelTitle === 'Collections') {
            navigateToCollections(item.title, item.sublinks);
          } else {
            navigateToSubmenu(item.title, item.sublinks);
          }
        });
      } else {
        li.innerHTML = `
          <a href="${item.url}" class="mobile-nav-link ${!isMainMenu && panelTitle !== 'Menu' ? 'mobile-nav-link--subcategory' : ''}">
            <span>${item.title}</span>
          </a>
        `;
      }

      list.appendChild(li);
    });

    panel.appendChild(list);
    return panel;
  };

  // Navigation vers les collections (avec images)
  const navigateToCollections = (submenuTitle, items) => {
  const newPanel = createCollectionsPanel(items, submenuTitle);
  
  // Sauvegarder l'état actuel
  if (currentPanel) {
    navigationStack.push({
      panel: currentPanel,
      title: title.textContent
    });
  }

  // Ajouter le nouveau panneau au DOM
  content.appendChild(newPanel);
  allPanels.push(newPanel);

  // Animation : cacher l'ancien, montrer le nouveau
  if (currentPanel) {
    currentPanel.classList.remove('active');
    currentPanel.classList.add('prev');
  }
  
  setTimeout(() => {
    newPanel.classList.add('active');
  }, 50);

  currentPanel = newPanel;
  title.textContent = submenuTitle;
  back.style.display = 'flex';
};

  // Navigation vers un sous-menu standard
  const navigateToSubmenu = (submenuTitle, items) => {
  const newPanel = createPanel(items, submenuTitle);
  
  // Sauvegarder l'état actuel
  if (currentPanel) {
    navigationStack.push({
      panel: currentPanel,
      title: title.textContent
    });
  }

  // Ajouter le nouveau panneau au DOM
  content.appendChild(newPanel);
  allPanels.push(newPanel);

  // Animation : cacher l'ancien, montrer le nouveau
  if (currentPanel) {
    currentPanel.classList.remove('active');
    currentPanel.classList.add('prev');
  }
  
  setTimeout(() => {
    newPanel.classList.add('active');
  }, 50);

  currentPanel = newPanel;
  title.textContent = submenuTitle;
  back.style.display = 'flex';
};

  // Retour en arrière
  const goBack = () => {
  if (navigationStack.length === 0) return;

  const prevState = navigationStack.pop();
  
  // Masquer le panneau actuel SANS le supprimer
  if (currentPanel) {
    currentPanel.classList.remove('active');
    currentPanel.classList.remove('prev');
  }

  // Restaurer le panneau précédent
  if (prevState.panel) {
    prevState.panel.classList.remove('prev');
    
    // Petit délai pour l'animation
    setTimeout(() => {
      prevState.panel.classList.add('active');
    }, 50);
  }
  
  currentPanel = prevState.panel;
  title.textContent = prevState.title;

  // Gérer l'affichage du bouton retour
  if (navigationStack.length === 0) {
    back.style.display = 'none';
  }
};

  // Initialiser le menu principal
  const initMainMenu = () => {
  // Nettoyer le contenu
  while (content.firstChild) {
    content.removeChild(content.firstChild);
  }
  navigationStack = [];
  allPanels = [];
  
  const megaMenuData = getMegaMenuData();
  const mainMenuItems = [];

  // Récupérer les éléments du menu principal
  const mainMenu = document.querySelectorAll('.nav-link');
  mainMenu.forEach((link) => {
    const linkTitle = link.textContent.trim();
    const trigger = link.getAttribute('data-nav-trigger');
    
    if (trigger === '1' && megaMenuData.bijoux.length > 0) {
      mainMenuItems.push({
        title: linkTitle,
        hasSubmenu: true,
        sublinks: megaMenuData.bijoux
      });
    } else if (trigger === '2' && megaMenuData.collections.length > 0) {
      mainMenuItems.push({
        title: 'Collections',
        hasSubmenu: true,
        sublinks: megaMenuData.collections
      });
    } else if (trigger === '3' && megaMenuData.cadeaux.length > 0) {
      mainMenuItems.push({
        title: linkTitle,
        hasSubmenu: true,
        sublinks: megaMenuData.cadeaux
      });
    } else {
      mainMenuItems.push({
        title: linkTitle,
        url: link.href || '#',
        hasSubmenu: false
      });
    }

    /*mainMenuItems.push({
        title: "Nos magasins",
        url: '/pages/nos-boutiques',
        hasSubmenu: false
    });*/
  });
  
  mainMenuItems.push({
    title: "Nos magasins",
    url: '/pages/nos-boutiques',
    hasSubmenu: false
  });

  // Créer le panneau principal
  const mainPanel = createPanel(mainMenuItems, 'Menu', true);
  content.appendChild(mainPanel);
  allPanels.push(mainPanel);
  
  setTimeout(() => {
    mainPanel.classList.add('active');
  }, 50);
  
  currentPanel = mainPanel;
  
  title.textContent = 'Menu';
  back.style.display = 'none';
};

  // Ouvrir le menu
  const openMenu = () => {
    overlay.classList.add('active');
    menu.classList.add('active');
    toggle.classList.add('active');
    document.body.classList.add('mobile-menu-open');
    document.body.style.overflow = 'hidden';
    
    // Initialiser le menu principal
    initMainMenu();
  };

  // Fermer le menu
  const closeMenu = () => {
  overlay.classList.remove('active');
  menu.classList.remove('active');
  toggle.classList.remove('active');
  document.body.classList.remove('mobile-menu-open');
  document.body.style.overflow = '';
  
  // Nettoyer après fermeture
  setTimeout(() => {
    while (content.firstChild) {
      content.removeChild(content.firstChild);
    }
    navigationStack = [];
    allPanels = [];
    currentPanel = null;
  }, 300);
};

  // Event listeners
  toggle.addEventListener('click', () => {
    if (menu.classList.contains('active')) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  overlay.addEventListener('click', closeMenu);
  close.addEventListener('click', closeMenu);
  back.addEventListener('click', goBack);

  // Fermer avec Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && menu.classList.contains('active')) {
      closeMenu();
    }
  });
}

  function setupSearch() {
    const searchInput = document.querySelector('.search-input');
    if (!searchInput) return;

    // Add search functionality here if needed
    searchInput.addEventListener('focus', () => {
      searchInput.parentElement.classList.add('focused');
    });

    searchInput.addEventListener('blur', () => {
      searchInput.parentElement.classList.remove('focused');
    });
  }

  function updateCartCount() {
    // Listen for cart updates
    document.addEventListener('cart:updated', (event) => {
      const cartCount = document.querySelector('.cart-count');
      if (cartCount && event.detail && event.detail.cart) {
        cartCount.textContent = event.detail.cart.item_count;
        cartCount.setAttribute('data-cart-count', event.detail.cart.item_count);
      }
    });
  }

  function setupMegaMenus() {
    // Délai pour s'assurer que tous les éléments sont dans le DOM
    setTimeout(() => {
      initMegaMenuHover();
    }, 100);
  }

  function initMegaMenuHover() {
    const navLinks = document.querySelectorAll('.nav-link[data-nav-trigger]');
    const allMegaMenus = document.querySelectorAll('.mega-menu-bijoux, .mega-menu-collections, .mega-menu-cadeaux');
    const header = document.querySelector('.header');
    const navigation = document.querySelector('.header__navigation');
    
    let hoverTimeout = null;
    
    // Initialiser l'état des mega menus
    allMegaMenus.forEach(menu => {
      menu.style.opacity = '0';
      menu.style.visibility = 'hidden';
      menu.style.transform = 'translateX(-50%) translateY(-10px)';
      menu.style.transition = 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)';
    });
    
    const showMegaMenu = (menuToShow) => {
      // Masquer tous les autres menus
      allMegaMenus.forEach(menu => {
        if (menu !== menuToShow) {
          menu.style.opacity = '0';
          menu.style.visibility = 'hidden';
          menu.style.transform = 'translateX(-50%) translateY(-10px)';
        }
      });
      
      // Afficher le menu demandé
      if (menuToShow) {
        menuToShow.style.opacity = '1';
        menuToShow.style.visibility = 'visible';
        menuToShow.style.transform = 'translateX(-50%) translateY(20px)';
      }
      
      // Mettre à jour l'état du header
      updateHeaderState();
    };
    
    const hideAllMegaMenus = () => {
      allMegaMenus.forEach(menu => {
        menu.style.opacity = '0';
        menu.style.visibility = 'hidden';
        menu.style.transform = 'translateX(-50%) translateY(-10px)';
      });
      
      // Mettre à jour l'état du header
      setTimeout(() => {
        updateHeaderState();
      }, 100);
    };
    
    // Configuration des événements de navigation
    navLinks.forEach(navLink => {
      const navTrigger = navLink.getAttribute('data-nav-trigger');
      const matchingMegaMenu = document.querySelector(
        `.mega-menu-bijoux[data-nav-trigger="${navTrigger}"], 
         .mega-menu-collections[data-nav-trigger="${navTrigger}"], 
         .mega-menu-cadeaux[data-nav-trigger="${navTrigger}"]`
      );
      
      const navItem = navLink.closest('.nav-item');
      if (!navItem) return;



      navItem.addEventListener('mouseenter', () => {
        clearTimeout(hoverTimeout);
        if (matchingMegaMenu) {
          showMegaMenu(matchingMegaMenu);
        } else {
          // Hide all mega menus when hovering non-mega menu items
          hideAllMegaMenus();
          updateHeaderState();
        }
      });
      
      navItem.addEventListener('mouseleave', () => {
        // Mettre à jour l'état quand on quitte un élément de navigation
        setTimeout(() => {
          updateHeaderState();
        }, 50);
      });
    });
    
    // Gestion des sorties de zone
    if (navigation) {
      navigation.addEventListener('mouseleave', (e) => {
        if (e.relatedTarget && e.relatedTarget.closest('.mega-menu-bijoux, .mega-menu-collections, .mega-menu-cadeaux')) {
          return;
        }
        
        hoverTimeout = setTimeout(() => {
          hideAllMegaMenus();
        }, 75);
      });
    }
    
    allMegaMenus.forEach(menu => {
      menu.addEventListener('mouseenter', () => {
        clearTimeout(hoverTimeout);
      });
      
      menu.addEventListener('mouseleave', (e) => {
        if (e.relatedTarget && e.relatedTarget.closest('.header__navigation')) {
          return;
        }
        
        hoverTimeout = setTimeout(() => {
          hideAllMegaMenus();
        }, 75);
      });
    });
  }

  // Ajuster le margin-top du body en fonction de la hauteur du header
function setBodyMarginTop() {
  const header = document.querySelector('.header');
  const hasHeroAccueil = document.querySelector('.hero-accueil');
  const mobileHeader = document.querySelector('.header__mobile');
  const announcement = document.querySelector('.header__announcement');
  const countdownTimer = document.querySelector('.countdown-timer-block');
  
  // Hauteur du countdown timer si présent
  const countdownHeight = countdownTimer?.offsetHeight || 0;
  
  if(!hasHeroAccueil) {
    if (window.innerWidth <= 768) {
        // Mobile
        const announcementHeight = announcement?.offsetHeight || 0;
        const mobileHeaderHeight = mobileHeader?.offsetHeight || 0;
        document.body.style.marginTop = `${countdownHeight + announcementHeight + mobileHeaderHeight}px`;
      } else {
        // Desktop
        const announcementHeight = announcement?.offsetHeight || 0;
        const mainHeaderHeight = document.querySelector('.header__main')?.offsetHeight || 0;
        document.body.style.marginTop = `${countdownHeight + announcementHeight + mainHeaderHeight}px`;
      }
  }else{
    document.body.style.marginTop = `${countdownHeight}px`;
  }
  
}

// Appeler au chargement et au redimensionnement
document.addEventListener('DOMContentLoaded', setBodyMarginTop);
window.addEventListener('resize', setBodyMarginTop);

// Appeler après le chargement complet (pour les images et scripts tiers)
window.addEventListener('load', setBodyMarginTop);

  // Gestion unifiée du logo - le CSS gère déjà l'affichage via les classes
  // La logique de scroll et hover est déjà gérée par updateHeaderState()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  // Video Modal Functions
  function openVideoModal(videoUrl) {
    const modal = document.getElementById('video-modal');
    const iframe = document.getElementById('video-iframe');
    
    if (modal && iframe) {
      // Convert YouTube URL to embed format
      let embedUrl = '';
      if (videoUrl.includes('youtube.com/watch')) {
        const videoId = videoUrl.split('v=')[1]?.split('&')[0];
        embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
      } else if (videoUrl.includes('youtu.be/')) {
        const videoId = videoUrl.split('youtu.be/')[1]?.split('?')[0];
        embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
      } else if (videoUrl.includes('vimeo.com/')) {
        const videoId = videoUrl.split('vimeo.com/')[1];
        embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
      } else {
        embedUrl = videoUrl;
      }
      
      iframe.src = embedUrl;
      modal.style.display = 'flex';
      
      // Prevent body scroll
      document.body.style.overflow = 'hidden';
    }
  }
  
  function closeVideoModal() {
    const modal = document.getElementById('video-modal');
    const iframe = document.getElementById('video-iframe');
    
    if (modal && iframe) {
      iframe.src = '';
      modal.style.display = 'none';
      
      // Restore body scroll
      document.body.style.overflow = '';
    }
  }
  
  // Close modal on ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeVideoModal();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"] && !Shopify.designMode) return;
  try {
    
// Search Results - Gestion identique à Collection Products Grid
document.addEventListener('DOMContentLoaded', () => {
  console.log('Search Results Grid: Initialisation...');
  
  const debugMode = false;
  
  const searchGrid = document.querySelector('[data-search-grid]');
  if (!searchGrid) {
    console.error('❌ Search grid non trouvée');
    return;
  }

  // Éléments DOM
  const searchForm = searchGrid.querySelector('[data-search-form]');
  const resultsContainer = searchGrid.querySelector('[data-search-results]');
  const typeFilters = searchGrid.querySelectorAll('[data-type-filter]');

  let currentUrl = new URL(window.location.href);

  // Gestion des filtres par type
  const updateTypeFilter = (typeValue) => {
    if (debugMode) {
      console.log(`🔄 Changement de type: ${typeValue}`);
    }
    
    if (typeValue === 'all') {
      currentUrl.searchParams.delete('type');
    } else {
      currentUrl.searchParams.set('type', typeValue);
    }
    
    currentUrl.searchParams.delete('page');
    updateSearch();
  };

  const updateSearch = () => {
    if (debugMode) {
      console.log('🔄 Mise à jour de la recherche...');
      console.log('🌍 Redirection vers:', currentUrl.toString());
    }
    
    window.location.href = currentUrl.toString();
  };

  // Event Listeners pour les filtres de type
  typeFilters.forEach(filter => {
    filter.addEventListener('click', (e) => {
      const typeValue = e.target.getAttribute('data-type-filter');
      updateTypeFilter(typeValue);
    });
  });

  // Masquer/afficher les résultats selon le filtre actif
  const filterResults = () => {
    const activeType = currentUrl.searchParams.get('type');
    const resultItems = searchGrid.querySelectorAll('[data-result-type]');
    
    resultItems.forEach(item => {
      const itemType = item.getAttribute('data-result-type');
      if (!activeType || activeType === 'all' || itemType === activeType) {
        item.style.display = 'block';
      } else {
        item.style.display = 'none';
      }
    });
  };

  // Initialisation
  filterResults();
  
  if (debugMode) {
    console.log('✅ Search Results Grid initialisé avec succès');
    console.log('📊 État initial:', {
      url: currentUrl.toString(),
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  class StoreLocator {
    constructor(sectionId) {
      this.sectionId = sectionId;
      this.pins = document.querySelectorAll(`#mapPins-${sectionId} .js-map-pin`);
      this.cards = document.querySelectorAll(`#storesList-${sectionId} .js-store-card`);
      this.mapContainer = document.querySelector(`#StoreLocator-${sectionId} .store-locator__map-svg`);
      this.pinsContainer = document.querySelector(`#mapPins-${sectionId}`);
      this.svg = this.mapContainer ? this.mapContainer.querySelector('svg') : null;
      this.activeRegion = null;
      this.activeCard = null;
      this.resizeObserver = null;
      
      this.init();
    }
    
    init() {
      // État initial : tout est visible, rien n'est sélectionné
      
      // Événements sur les pins
      this.pins.forEach(pin => {
        pin.addEventListener('click', (e) => {
          e.preventDefault();
          const region = pin.dataset.region;
          this.selectRegion(region);
        });
      });
      
      // Événements sur les cartes
      this.cards.forEach(card => {
        card.addEventListener('click', (e) => {
          e.preventDefault();
          const region = card.dataset.region;
          const storeId = card.dataset.storeId;
          this.selectRegionAndCard(region, storeId);
        });
      });
      
      // Synchroniser les pins avec le SVG au chargement
      this.waitForSVGLoad().then(() => {
        this.syncPinsWithSVG();
      });
      
      // Utiliser ResizeObserver pour détecter les changements de taille du container
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          this.syncPinsWithSVG();
        });
        
        if (this.mapContainer) {
          this.resizeObserver.observe(this.mapContainer);
        }
      } else {
        // Fallback pour les navigateurs qui ne supportent pas ResizeObserver
        let resizeTimeout;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            this.syncPinsWithSVG();
          }, 100);
        });
      }
    }
    
    waitForSVGLoad() {
      return new Promise((resolve) => {
        if (!this.svg) {
          resolve();
          return;
        }
        
        // Si le SVG est déjà chargé (inline SVG)
        if (this.svg.getBBox) {
          try {
            this.svg.getBBox();
            resolve();
            return;
          } catch (e) {
            // Pas encore prêt
          }
        }
        
        // Attendre que le SVG soit complètement chargé
        if (this.svg.complete) {
          resolve();
        } else {
          this.svg.addEventListener('load', () => resolve());
          // Timeout de sécurité
          setTimeout(() => resolve(), 500);
        }
      });
    }
    
    syncPinsWithSVG() {
      if (!this.svg || !this.pinsContainer || !this.mapContainer) return;
      
      // Obtenir les dimensions du container de la carte
      const containerRect = this.mapContainer.getBoundingClientRect();
      
      // Vérifier que le container a des dimensions valides
      if (containerRect.width === 0 || containerRect.height === 0) {
        return;
      }
      
      // Obtenir les dimensions intrinsèques du SVG depuis viewBox ou width/height
      let svgIntrinsicWidth, svgIntrinsicHeight;
      
      // Essayer d'abord avec viewBox
      if (this.svg.viewBox && this.svg.viewBox.baseVal && this.svg.viewBox.baseVal.width > 0) {
        svgIntrinsicWidth = this.svg.viewBox.baseVal.width;
        svgIntrinsicHeight = this.svg.viewBox.baseVal.height;
      } 
      // Sinon essayer avec les attributs width/height
      else if (this.svg.hasAttribute('width') && this.svg.hasAttribute('height')) {
        svgIntrinsicWidth = parseFloat(this.svg.getAttribute('width'));
        svgIntrinsicHeight = parseFloat(this.svg.getAttribute('height'));
      }
      // Sinon utiliser getBBox comme dernier recours
      else {
        try {
          const bbox = this.svg.getBBox();
          svgIntrinsicWidth = bbox.width;
          svgIntrinsicHeight = bbox.height;
        } catch (e) {
          // Si rien ne fonctionne, utiliser des valeurs par défaut
          svgIntrinsicWidth = 800;
          svgIntrinsicHeight = 600;
        }
      }
      
      // Calculer le ratio d'aspect du SVG
      const svgRatio = svgIntrinsicWidth / svgIntrinsicHeight;
      const containerRatio = containerRect.width / containerRect.height;
      
      // Calculer les dimensions réelles du SVG après object-fit: contain
      let svgDisplayWidth, svgDisplayHeight;
      
      if (containerRatio > svgRatio) {
        // Le container est plus large que le SVG : le SVG est limité en hauteur
        svgDisplayHeight = containerRect.height;
        svgDisplayWidth = svgDisplayHeight * svgRatio;
      } else {
        // Le container est plus haut que le SVG : le SVG est limité en largeur
        svgDisplayWidth = containerRect.width;
        svgDisplayHeight = svgDisplayWidth / svgRatio;
      }
      
      // Calculer les offsets pour centrer le SVG dans son container
      const offsetX = (containerRect.width - svgDisplayWidth) / 2;
      const offsetY = (containerRect.height - svgDisplayHeight) / 2;
      
      // Appliquer ces dimensions et position au container des pins
      this.pinsContainer.style.width = svgDisplayWidth + 'px';
      this.pinsContainer.style.height = svgDisplayHeight + 'px';
      this.pinsContainer.style.left = offsetX + 'px';
      this.pinsContainer.style.top = offsetY + 'px';
    }
    
    selectRegion(region) {
      const sidebar = document.querySelector(`#StoreLocator-${this.sectionId} .store-locator__sidebar`);

      // Si on clique sur la même région, on désélectionne
      if (this.activeRegion === region) {
        this.resetAll();
        if (sidebar) {
          sidebar.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        return;
      }
      
      this.activeRegion = region;
      this.activeCard = null;
      
      // Filtrer les pins
      this.pins.forEach(pin => {
        if (pin.dataset.region === region) {
          pin.classList.add('is-active');
          pin.classList.remove('is-dimmed');
        } else {
          pin.classList.remove('is-active');
          pin.classList.add('is-dimmed');
        }
      });
      
      // Filtrer les cartes : afficher uniquement celles de la région
      this.cards.forEach(card => {
        if (card.dataset.region === region) {
          card.classList.remove('is-filtered-out');
        } else {
          card.classList.add('is-filtered-out');
        }
        card.classList.remove('is-active');
      });

      if (sidebar) {
        sidebar.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
    
    selectRegionAndCard(region, storeId) {
      // Sélectionner la région
      this.activeRegion = region;
      this.activeCard = storeId;
      
      // Filtrer les pins
      this.pins.forEach(pin => {
        if (pin.dataset.region === region) {
          pin.classList.add('is-active');
          pin.classList.remove('is-dimmed');
        } else {
          pin.classList.remove('is-active');
          pin.classList.add('is-dimmed');
        }
      });
      
      // Filtrer et activer les cartes
      this.cards.forEach(card => {
        if (card.dataset.region === region) {
          card.classList.remove('is-filtered-out');
          // Activer uniquement la carte cliquée
          if (card.dataset.storeId === storeId) {
            card.classList.add('is-active');
          } else {
            card.classList.remove('is-active');
          }
        } else {
          card.classList.add('is-filtered-out');
          card.classList.remove('is-active');
        }
      });
    }
    
    resetAll() {
      // Revenir à l'état initial
      this.activeRegion = null;
      this.activeCard = null;
      
      // Réinitialiser les pins
      this.pins.forEach(pin => {
        pin.classList.remove('is-active', 'is-dimmed');
      });
      
      // Réinitialiser les cartes
      this.cards.forEach(card => {
        card.classList.remove('is-filtered-out', 'is-active');
      });
    }
    
    destroy() {
      // Nettoyer le ResizeObserver
      if (this.resizeObserver && this.mapContainer) {
        this.resizeObserver.unobserve(this.mapContainer);
        this.resizeObserver.disconnect();
      }
    }
  }
  
  // Initialisation
  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.store-locator');
    sections.forEach(section => {
      const sectionId = section.id.replace('StoreLocator-', '');
      new StoreLocator(sectionId);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
